// Dedicated service enquiry pages with their own embedded forms.
// Customer-facing copy provided verbatim by the owner — do not add prices,
// certifications, guarantees or experience claims here.

export const SERVICE_ENQUIRY_PAGES = {
  "defect-cost-estimation-dubai": {
    serviceKey: "defect-cost-estimation",
    serviceName: "Defect cost estimation",
    breadcrumb: "Defect Cost Estimation",
    title: "Defect Cost Estimation Dubai | Repair Cost Estimates | Fedari",
    description: "Itemised estimates of the anticipated cost of rectifying identified property defects in Dubai. Prioritise remedial works and assess contractor quotations with confidence.",
    h1: "Defect Cost Estimation",
    subtitle: "Understand repair costs before you commit.",
    intro: "Fedari Building Inspection LLC provides itemised estimates of the anticipated cost of rectifying identified property defects. Understand your potential repair budget, prioritise remedial works and assess contractor quotations with greater confidence.",
    receive: [
      "A breakdown of identified defects and proposed remedial works.",
      "Indicative repair costs for each item.",
      "Repair priorities based on the inspection findings.",
      "A summary of the estimated rectification budget.",
    ],
    note: "Cost estimates are indicative and provided for budgeting purposes. Final costs depend on the confirmed scope, materials, site conditions and contractor quotations.",
    cta: "Request a Defect Cost Estimate",
    upload: true,
    projectStage: false,
    related: [
      { label: "Book a Site Inspection", href: "/site-inspection-dubai" },
      { label: "Property snagging Dubai", href: "/property-snagging-dubai" },
      { label: "DLP / warranty inspection", href: "/dlp-warranty-inspection-dubai" },
    ],
  },
  "site-inspection-dubai": {
    serviceKey: "site-inspection",
    serviceName: "Site inspection",
    breadcrumb: "Site Inspection",
    title: "Site Inspection Dubai | Independent Property Inspection | Fedari",
    description: "Independent site inspections in Dubai for owners, buyers and investors. Accessible areas assessed, visible workmanship reviewed and defects documented photographically within the agreed scope.",
    h1: "Site Inspection",
    subtitle: "Clear findings. Practical recommendations. Greater confidence.",
    intro: "Fedari Building Inspection LLC offers independent site inspections to help property owners, buyers and investors understand the condition of their property or project. We assess accessible areas, review visible workmanship and document defects or unfinished works within the agreed inspection scope.",
    receive: [
      "An inspection of accessible areas within the agreed scope.",
      "Photographic documentation of visible defects and unfinished works.",
      "Clear findings and repair priorities.",
      "Practical recommendations to support discussions with contractors, developers or property managers.",
    ],
    note: null,
    cta: "Book a Site Inspection",
    upload: false,
    projectStage: true,
    related: [
      { label: "Request a Defect Cost Estimate", href: "/defect-cost-estimation-dubai" },
      { label: "Property snagging Dubai", href: "/property-snagging-dubai" },
      { label: "Resale property inspection", href: "/resale-property-inspection-dubai" },
    ],
  },
};

export const SERVICE_ENQUIRY_SLUGS = Object.keys(SERVICE_ENQUIRY_PAGES);
